export const getDiscountStorageValue = (orderInfo: any) => {
  return {
     discountsWhole: {
      type: orderInfo?.customDiscountInfo?.type,
      value: orderInfo?.customDiscountInfo?.value
    },
    discountsArr: orderInfo?.items?.map((item: any) => 
    ({
      id: item.variantId,
      type: item?.customDiscountInfo?.type,
      value: item?.customDiscountInfo?.value,
      quantity: item.quantity
    })) ?? []
  }
};
